import React from 'react';
import {
  Typography,
  Select,
  MenuItem,
  Box,
  Button,
  makeStyles,
  Switch,
  InputLabel,
  FormControl,
  withStyles,
  FormHelperText,
  Checkbox,
  ListItemText,
  ListItem,
  Divider,
  IconButton,
} from '@material-ui/core';
import { KeyboardArrowDown, ReportProblemOutlined } from '@material-ui/icons';
import IOSSwitch from 'components/Common/IOSSwitch';
import DynamicIcon from 'components/Common/DynamicIcon';
import { DateField, DropdownField } from '../Common/Filters';

const useStyles = makeStyles((theme) => ({
  twoLevelBox: {
    [theme.breakpoints.up('md')]: {
      width: '55%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

function UnsupportedWidget({ type, insideDialog, ...props }) {
  // return <Typography>{JSON.stringify(props)} - (Unsupported widget: {type})</Typography>;
  return <></>;
}

function SectionHeadingWidget({
  logo,
  title,
  subtitle,
  info,
  insideDialog,
  button,
  handleDeeplink,
}) {
  return title || subtitle || logo ? (
    <Box p={1} width="100%" style={{ padding: '10px 10px 0 10px' }}>
      {logo && (
        <Box>
          <img src={logo} style={{ height: 60, objectFit: 'contain' }}></img>
        </Box>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        {title && (
          <Typography
            variant="h5"
            style={{
              fontWeight: 'bold',
              color: '#505050',
              fontSize: insideDialog ? '1.2rem' : '1.8rem',
            }}
          >
            {title}
          </Typography>
        )}
        {button && (
          <Button
            variant="contained"
            style={{
              background: '#233C97',
              color: 'white',
            }}
            onClick={() =>
              handleDeeplink(button.deep_link, button.apiType || 1)
            }
          >
            {button.title}
          </Button>
        )}
      </div>
      {subtitle && (
        <Typography
          variant="subtitle2"
          style={{
            fontSize: insideDialog ? '14px' : '16px',
            fontWeight: 'bold',
          }}
        >
          {subtitle}
        </Typography>
      )}
      {info && (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            marginTop: 4,
          }}
        >
          <DynamicIcon
            iconId={154}
            style={{
              height: 14,
              width: 14,
              marginTop: 4,
              marginRight: 4,
            }}
          />
          <Typography variant="subtitle2" style={{ fontSize: '14px' }}>
            {info}
          </Typography>
        </div>
      )}
    </Box>
  ) : null;
}

function SectionHeadingSeeMoreWidget({
  title,
  subtitle,
  otherProps: { see_more },
  handleDeeplink,
}) {
  return (
    <>
      <Box display="flex" p={1}>
        <Box flexGrow={1}>
          <Typography
            variant="h5"
            style={{ fontWeight: 'bold', color: '#505050', fontSize: '1.8rem' }}
          >
            {title}
          </Typography>
        </Box>
        {see_more && (
          <Box>
            <Typography
              variant="h6"
              color="primary"
              onClick={() =>
                handleDeeplink(see_more.deep_link, { target: '_self' })
              }
            >
              {see_more.text}
            </Typography>
          </Box>
        )}
      </Box>
      {subtitle && (
        <Typography
          variant="subtitle2"
          style={{ fontSize: '16px', fontWeight: 'bold' }}
        >
          {subtitle}
        </Typography>
      )}
    </>
  );
}

function EmptySectionWidget() {
  return <></>;
}

function DropdownMenuWidget({
  id,
  title,
  subtitle,
  selection,
  handleDeeplink,
  currentDeeplink,
  setCurrentDeeplink,
  ...props
}) {
  const onChange = (event) => {
    setCurrentDeeplink(event.target.value);
  };
  // const value = (selection || []).find((menuItem) => menuItem.id === id);
  return (
    <Box
      p={2}
      display="flex"
      justifyContent={title ? 'space-between' : 'flex-end'}
      alignItems="center"
    >
      <Box p={1}>
        <Typography
          variant="h5"
          style={{ fontWeight: 'bold', color: '#505050', fontSize: '1.8rem' }}
        >
          {title}
        </Typography>
        {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
      </Box>
      {selection && (
        <FormControl>
          <Select
            style={{ padding: '0px 15px' }}
            value={currentDeeplink}
            onChange={onChange}
            disableUnderline
            IconComponent={(props) => (
              <KeyboardArrowDown
                {...props}
                style={{ color: '#909090', marginTop: 1, marginRight: 10 }}
              />
            )}
          >
            {selection &&
              selection.map((menuItem, index) => (
                <MenuItem key={index} value={menuItem.deep_link}>
                  {menuItem.title}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}

const SectionHeadingActionWidget = ({
  title,
  subtitle,
  button,
  tinge,
  otherProps,
  ...props
}) => {
  const { handleUpdateSection, selectedCards } = otherProps;
  return (
    <Box p={2} display="flex" justifyContent="space-between" width="100%">
      {tinge && tinge === true ? (
        <div style={{ marginLeft: '20px' }}>
          <Typography
            style={{ fontSize: '1.8rem', color: '#505050', fontWeight: 'bold' }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              style={{ fontSize: '16px', color: '#898989', fontWeight: 'bold' }}
            >
              {subtitle}
            </Typography>
          )}
          <div
            style={{
              background:
                'transparent linear-gradient(265deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
              borderRadius: '2px',
              width: '32px',
              height: '4px',
              margin: '20px 0 15px 0',
            }}
          ></div>
        </div>
      ) : (
        <div>
          <Typography
            variant="h6"
            style={{ fontSize: '1.8rem', color: '#505050', fontWeight: 'bold' }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="subtitle2"
              style={{ fontSize: '16px', fontWeight: 'bold' }}
            >
              {subtitle}
            </Typography>
          )}
        </div>
      )}
      {button && (
        <Button
          variant="contained"
          style={{
            background: '#233C97',
            color: 'white',
          }}
          onClick={() =>
            props.handleDeeplink(button.deep_link, button.apiType || 1)
          }
        >
          {button.title}
        </Button>
      )}
    </Box>
  );
};

function TwoLevelHeadingSection({ content, handleDeeplink }) {
  const classes = useStyles();

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        padding: '16px 16px 0 16px',
      }}
    >
      <Box p={1} className={classes.twoLevelBox}>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            padding: '0px 0px 15px 0px',
            borderBottom: '1px solid #959595',
          }}
        >
          <Typography
            variant="h5"
            style={{
              fontWeight: 'bold',
              color: '#505050',
              fontSize: '1.55rem',
              textTransform: 'uppercase',
            }}
          >
            {content.level1.title}
          </Typography>

          {content.level1.subtitle && (
            <Typography
              variant="h5"
              style={{
                marginLeft: 10,
                fontWeight: '500',
                color: '#909090',
                fontSize: '1.55rem',
                textTransform: 'uppercase',
              }}
            >
              {'/ ' + content.level1.subtitle}
            </Typography>
          )}
        </div>
        {content.level2 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              paddingTop: 25,
              paddingBottom: 20,
            }}
          >
            <Typography
              style={{
                fontWeight: 'bold',
                color: '#505050',
                fontSize: '1.3rem',
                textTransform: 'uppercase',
              }}
            >
              {content.level2.title}
            </Typography>
            {content.level2.subtitle && (
              <Typography
                style={{
                  marginLeft: 10,
                  fontWeight: '500',
                  color: '#909090',
                  fontSize: '1.3rem',
                  textTransform: 'uppercase',
                }}
              >
                {content.level2.subtitle}
              </Typography>
            )}
          </div>
        )}
        {content.info_message && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              paddingBottom: 5,
              marginTop: 15,
            }}
          >
            {content.info_message.iconId && (
              <DynamicIcon
                iconId={content.info_message.iconId}
                style={{
                  width: 20,
                  height: 20,
                  lineHeight: 15,
                  marginRight: 10,
                  marginTop: 1,
                }}
              />
            )}
            <Typography style={{ color: '#959595', fontSize: 15 }}>
              {content.info_message.message}
            </Typography>
          </div>
        )}
      </Box>
      <div
        style={{
          display: 'flex',
        }}
      >
        {content.level1.buttons &&
          content.level1.buttons.map((button, index) => (
            <Button
              variant="contained"
              color="primary"
              style={{
                marginLeft: 10,
                background: '#233C97',
                color: '#ffffff',
                paddingLeft: 15,
                paddingRight: 15,
                height: 40,
                maxWidth: 250,
                borderRadius: 5,
                marginRight: 8,
              }}
              onClick={() => {
                button.isCopyButton
                  ? navigator.clipboard.writeText(button.copyText)
                  : handleDeeplink(button.deep_link, button.apiType || 1);
              }}
            >
              {button.iconId && (
                <DynamicIcon
                  iconId={button.iconId}
                  insideColoredButton
                  style={{
                    height: 20,
                    width: 20,
                    color: '#ffffff',
                    fontSize: 15,
                  }}
                />
              )}
              {button.title && (
                <div
                  style={{
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                    marginLeft: 5,
                    color: '#ffffff',
                  }}
                >
                  {button.title}
                </div>
              )}
            </Button>
          ))}
      </div>
    </div>
  );
}

const FilterDropDown = (props) => {
  const classes = useStyles();

  React.useEffect(() => {
    props.selectFilter({ [props._key]: props.selected });
  }, [props.selected]);

  return (
    <FormControl
      className={classes.formControl}
      style={{
        border: '1px solid #e8e8e8',
        borderRadius: 5,
        margin: '0px 8px',
      }}
    >
      <Select
        value={props.selectedFilters[props._key] || ''}
        style={{ minWidth: 150, padding: '0px 15px' }}
        multiple={props.multiselect}
        disableUnderline
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        IconComponent={(props) => (
          <KeyboardArrowDown
            {...props}
            style={{ color: '#909090', marginTop: 1, marginRight: 10 }}
          />
        )}
        onChange={(e) => props.selectFilter({ [props._key]: e.target.value })}
      >
        <MenuItem value="" disabled>
          {props.title || 'Filter'}
        </MenuItem>
        {(props.selection || []).map((item) => (
          <MenuItem
            value={item.id}
            component={(props) => (
              <ListItem button style={{ cursor: 'pointer' }} {...props}>
                {props.multiselect && (
                  <Checkbox
                    style={{ padding: 0, marginRight: 8 }}
                    checked={(props.selectedFilters[props._key] || [])[
                      props.selection.key
                    ].includes(item.id)}
                  />
                )}
                <ListItemText primary={item.title} />
              </ListItem>
            )}
          >
            {item.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const FilterSwitch = (props) => {
  const inactiveState = (props.selection || [])[0];
  const activeState = (props.selection || [])[1];

  React.useEffect(() => {
    props.selectFilter({ [props._key]: props.selected });
  }, [props.selected]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        border: '1px solid #e8e8e8',
        borderRadius: 5,
        margin: '0px 8px',
        padding: '0 10px',
      }}
    >
      <Typography>
        {(props.selectedFilters[props._key] || props.selected) ===
        activeState.id
          ? activeState.title
          : inactiveState.title}
      </Typography>
      <IOSSwitch
        checked={
          (props.selectedFilters[props._key] || props.selected) ===
          activeState.id
        }
        onChange={(e) =>
          props.selectFilter({
            [props._key]: (e.target.checked ? activeState : inactiveState).id,
          })
        }
        activeLabel={activeState.title}
        inactiveLabel={inactiveState.title}
        inputProps={{ 'aria-label': 'secondary checkbox' }}
      />
    </div>
  );
};

const FilterComponentLibrary = (props) => {
  const filterComponents = {
    dropdown: DropdownField,
    date: DateField,
  };
  const CurrentComponent = filterComponents[props.type];

  return <CurrentComponent {...props} />;
};

const FilterBox = ({ filters, ...props }) => {
  return (
    <div
      style={{
        padding: '0px 10px',
        display: 'flex',
        justifyContent:
          (filters || []).length > 1 ? 'space-between' : 'flex-end',
        alignItems: 'center',
      }}
    >
      {(filters || []).map((filter) => (
        <FilterComponentLibrary
          {...filter}
          _key={filter.key}
          field={filter}
          {...props}
        />
      ))}
      <div
        style={{
          width: 40,
          height: 40,
          background: '#f9f9f9',
          margin: 10,
        }}
      >
        <IconButton
          disableRipple
          style={{ width: 40, height: 40, background: '#f9f9f9' }}
        >
          <DynamicIcon
            iconId={
              props.selectedFilters &&
              Object.keys(props.selectedFilters).length > 0
                ? 162
                : 160
            }
            style={{ height: 20, width: 20 }}
          />
        </IconButton>
      </div>
    </div>
  );
};

function FilterSection({
  title,
  subtitle,
  filters,
  baseDeeplink,
  setCurrentDeeplink,
  insideDialog,
  ...props
}) {
  const [selectedFilters, setSelectedFilters] = React.useState(null);
  const selectFilter = (filterSet) => {
    setSelectedFilters((filters) => ({ ...filters, ...filterSet }));
  };
  const [localFilters, setLocalFilters] = React.useState({});
  React.useEffect(() => {
    selectedFilters &&
      Object.keys(selectedFilters).length > 0 &&
      setLocalFilters({ ...selectedFilters });
  }, [selectedFilters]);

  const removeFilter = (filter) => {
    let res = {};
    for (let key in localFilters) {
      if (key != filter.key) res[key] = localFilters[key];
    }
    setLocalFilters({ ...res });
    Object.keys(selectedFilters).length > 0 && setSelectedFilters({ ...res });
  };

  React.useEffect(() => {
    selectedFilters &&
      setCurrentDeeplink(
        `${baseDeeplink}${
          Object.keys(selectedFilters).length > 0
            ? `query${Object.keys(selectedFilters || {}).reduce(
                (queryString, currentFilter) =>
                  queryString +
                  (selectedFilters[currentFilter]
                    ? `/${currentFilter}/${selectedFilters[currentFilter]}`
                    : ''),
                ''
              )}`
            : ''
        } `
      );
  }, [selectedFilters, baseDeeplink]);

  React.useEffect(() => {
    if (filters) {
      let currentFilters = {};
      filters.forEach((filter) => {
        if (!!filter.selected && filter.selected != selectedFilters[filter.key])
          currentFilters[filter.key] = filter.selected;
      });
      Object.keys(currentFilters).length > 0 &&
        setSelectedFilters(currentFilters);
    }
  }, [filters]);

  return (
    <Box
      p={1}
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div>
        {title && (
          <Typography
            variant="h5"
            style={{
              fontWeight: 'bold',
              color: '#505050',
              fontSize: insideDialog ? '1.2rem' : '1.8rem',
            }}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            variant="subtitle2"
            style={{
              fontSize: insideDialog ? '14px' : '16px',
              fontWeight: 'bold',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </div>
      <div>
        {filters && (
          <FilterBox
            filters={filters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            selectFilter={selectFilter}
            removeFilter={removeFilter}
            localFilters={localFilters}
            setLocalFilters={setLocalFilters}
          />
        )}
      </div>
    </Box>
  );
}

function ImageLogoWidget({ logo, title, subtitle, insideDialog }) {
  return title || subtitle ? (
    <Box p={1} style={{ display: 'flex', marginBotton: '100px' }}>
      {logo && (
        <img
          alt=""
          src={logo}
          style={{
            objectFit: 'cover',
            height: 100,
            width: 100,
            borderRadius: 7,
          }}
          onClick={() => {}}
        />
      )}
      {title && (
        <Typography
          variant="title"
          style={{
            fontSize: insideDialog ? '40px' : '50px',
            fontWeight: 'bold',
            margin: '0 40px',
            alignSelf: 'center',
          }}
        >
          {title}
        </Typography>
      )}
      <Divider />
    </Box>
  ) : null;
}

const sectionWidgets = {
  card_heading: SectionHeadingWidget,
  card_heading_subtitle: SectionHeadingWidget,
  empty_section: EmptySectionWidget,
  card_heading_with_selection: DropdownMenuWidget, // TODO: change this
  section_title_collapsible: SectionHeadingWidget, // TODO: add collapsible
  section_with_heading_and_see_more: SectionHeadingSeeMoreWidget,
  khali_section: EmptySectionWidget,
  grid_section: SectionHeadingActionWidget,
  background_section: SectionHeadingActionWidget,
  extreme_aligned_grid_section: SectionHeadingActionWidget,
  two_level_title_section: TwoLevelHeadingSection,
  grid_list_section: EmptySectionWidget,
  section_with_filters: FilterSection,
  uniform_grid_section: DropdownMenuWidget,
  section_with_image_logo: ImageLogoWidget,
};

export function SectionWidget(props) {
  const WidgetComponent = sectionWidgets[props.type] || UnsupportedWidget;
  return <WidgetComponent {...props.content} {...props} />;
}
